<template>
    <v-toolbar color="primary" dark app fixed scroll-off-screen>
        <v-toolbar-side-icon @click="$bus.$emit('nav-drawer.toggle')"></v-toolbar-side-icon>

        <!-- <v-toolbar-title></v-toolbar-title> -->

        <v-spacer></v-spacer>
        <v-text-field
            v-if="searching"
            placeholder="buscar"
            autofocus
            v-model="search"
        ></v-text-field>
        <v-btn icon @click="onSearchPress">
            <v-icon>search</v-icon>
        </v-btn>
        
    </v-toolbar>
</template>
<script>
export default {
    data(){
        return {
            searching: false,
            search: ''
        }
    },
    methods: {
        onSearchPress(){
            if(!this.searching){
                this.searching = !this.searching;
            }else{
                if(!this.search.length){
                    this.searching = !this.searching;
                }else{
                    this.startSearching();
                }
            }
        },
        startSearching(){
            const searchingIn = this.$route.path.substring(1);
            alert('Searching...' + searchingIn);
        }
    },
    created() {
    }
}
</script>


// WEBPACK FOOTER //
// src/components/UI/Toolbar/Toolbar.vue